import React, { useEffect, useState } from "react";
import { Container, MainText, AdditionalText, Line, InfoContainer, InfoTitle, ButtonWrapper, MainButton } from "./MainStyle";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // 스타일 임포트
import { Carousel } from "react-responsive-carousel"; // Carousel 컴포넌트 임포트
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap'

function Main() {
  const [showMainText, setShowMainText] = useState(true);
  const [showAdditionalText, setShowAdditionalText] = useState(false);
  const [scrollDirection, setScrollDirection] = useState("down");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      if (scrollY >= windowHeight / 3) {
        if (scrollDirection !== "up") {
          setShowMainText(false);
          setShowAdditionalText(true);
          setScrollDirection("up");
        }
      } else {
        if (scrollDirection !== "down") {
          setShowMainText(true);
          setShowAdditionalText(false);
          setScrollDirection("down");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollDirection]);

  return (
    <Container>
      <Button variant="light"
        style={{
          position: 'absolute', top: 0, right: 0, fontWeight: "700", fontSize: "0.8rem",
          margin: '10px', color: "#66CDAA", backgroudn: "white"
        }}>
        <Link to="/" style={{textDecoration:"none", color:"#66CDAA"}}>   
            한국어 버전으로 변경
        </Link> 
      </Button>
      <MainText visible={showMainText}>Hello, Ssook's World!</MainText>
      <Line />
      <AdditionalText visible={showAdditionalText}>Like 'Ssook'</AdditionalText>
      {showAdditionalText && (
        <InfoContainer>
          <InfoTitle>About Me_</InfoTitle>
          <Carousel showThumbs={false} showStatus={false} infiniteLoop autoPlay showIndicators={false} style={{ marginBottom: "100px" }}>
            <div style={{ width: "100%" }}>
              <ButtonWrapper>
                <Link to="/resume-eng">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Resume</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0', fontWeight: 'border' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                    In addition to boring stories such as studies, career paths, <br></br>
                    <b>An honest and light introduction</b>, such as favorite food and MBTI <br></br>
                    You can find them all here. <br />
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div>
              <ButtonWrapper>
                <Link to="/personality-eng">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Personality</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0', fontWeight: 'border' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                    It contains more detailed stories about my personality. <br></br>
                    In particular, you can find out <b>what kind of person</b> my acquaintances see me as here. <br></br>
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div style={{ marginBottom: "3%" }}>
              <ButtonWrapper>
                <Link to="/project-eng">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Project & TechStack</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                      <b>Only a few projects</b> are listed on my resume. <br></br>
                      This is because I select and write the content of the project depending on the job I applied for. <br></br>
                      From marketing to data analysis, planning, development, and service operation. Check it out at once!<br></br>
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div>
              <ButtonWrapper>
                <Link to="/award-eng">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Award & Certificate</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                    <b>The awards listed on my resume</b> are <b>only a small number.</b> <br></br>
                    This is because I only selected and wrote down a portion of the information that matches the job I applied for. <br></br>
                    Planning, development, and even National Assembly awards. Check out my award-winning career in various fields!<br></br>
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
          </Carousel>
        </InfoContainer>
      )}
    </Container>
  );
}

export default Main;
